module.exports = __webpack_public_path__ + "img/摄图网_500394447_banner_手拿七巧板（非企业商用）.eaefc1cc.png";